import React from 'react';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { SectionTitle, BlockHeading, ApiTable, CodeBlock, InfoCard } from '../../../components/apidocs';
import {
  HTTP_STATUS_HEADERS, HTTP_STATUS_ROWS,
  BUSINESS_ERROR_HEADERS, BUSINESS_ERROR_ROWS,
  ERROR_RESPONSE_SAMPLE,
} from '../data/errors';

const ErrorsSection: React.FC = () => (
  <div>
    <SectionTitle icon={faExclamationTriangle} iconColor="bg-gradient-to-br from-rose-400 to-red-500">
      Error Codes Reference
    </SectionTitle>
    <p className="text-gray-500 dark:text-slate-400 mb-6 text-sm">รายการ Error Codes ทั้งหมดที่ API อาจส่งกลับมา พร้อมวิธีแก้ไข</p>

    <BlockHeading>HTTP Status Codes</BlockHeading>
    <ApiTable headers={HTTP_STATUS_HEADERS} rows={HTTP_STATUS_ROWS} />

    <BlockHeading margin="mb-3 mt-8">Error Response Format</BlockHeading>
    <CodeBlock id="error-format" code={ERROR_RESPONSE_SAMPLE} label="error-response.json" />

    <BlockHeading margin="mb-3 mt-8">Common Business Errors</BlockHeading>
    <ApiTable headers={BUSINESS_ERROR_HEADERS} rows={BUSINESS_ERROR_ROWS} />

    <div className="mt-6">
      <InfoCard type="tip" title="Error Handling Tips">
        <ul className="space-y-1 list-disc list-inside">
          <li>ตรวจสอบ field <code className="bg-violet-100 dark:bg-violet-900/40 px-1 rounded text-xs font-mono">success</code> ก่อนเสมอ — ถ้าเป็น <code className="font-mono text-xs">false</code> ให้อ่าน <code className="bg-violet-100 dark:bg-violet-900/40 px-1 rounded text-xs font-mono">message</code></li>
          <li>ใช้ <code className="bg-violet-100 dark:bg-violet-900/40 px-1 rounded text-xs font-mono">error</code> code สำหรับ logic ฝั่ง client แทนการเช็ค message text</li>
          <li>Implement retry with exponential backoff สำหรับ 429 และ 500</li>
          <li>Log ทุก error response เพื่อ debug</li>
        </ul>
      </InfoCard>
    </div>
  </div>
);

export default ErrorsSection;
